module.exports = __webpack_public_path__ + "static/media/iconM6.800f7e9a.svg";